import Appsignal from "@appsignal/javascript";
import settings from "../settings";

const logger = ((): {sendError(err: Error): void, sendMessage(message: string): void} => {
  if (settings.appsignal_key) {
    // eslint-disable-next-line no-console
    console.log("Appsignal available");
    const appsignal = new Appsignal({
      key: settings.appsignal_key,
      revision: settings.heroku_slug_commit,
    });

    return {
      sendError: (err: Error) => {
        try {
          appsignal.sendError(err);
        } catch (error) {
          if (error instanceof Error) {
            // eslint-disable-next-line no-console
            console.log(error);
          }
        }
      },
      sendMessage: (message:string) => {
        try {
          throw new Error(message);
        } catch (error) {
          if (error instanceof Error) {
            appsignal.sendError(error);
          }
        }
      },
    };
  }
  return {
    sendError (err: Error) {
      // eslint-disable-next-line no-console
      console.log(err);
    },
    sendMessage (message: string) {
      // eslint-disable-next-line no-console
      console.log(message);
    },
  };
})();

export default logger;
